import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "settings-printer mt-1 mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
var _hoisted_3 = {
  key: 0
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "item-name"
}, "Device Location:", -1);

var _hoisted_5 = {
  class: "item-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings.devices")), 1), _ctx.hasHardwareLocation ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_row, {
    class: "items-row"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8,
        class: "d-flex fl-a-c"
      }, {
        default: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        class: "d-flex fl-a-c"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.hardwareLocation.deviceName), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])) : (_openBlock(), _createBlock(_component_el_form, {
    key: 1,
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("settings.device")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [true ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "deviceId",
                class: "w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.deviceId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _ctx.deviceId = $event;
                    }),
                    placeholder: _ctx.$t('select.device')
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, function (dev) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: dev.id || '',
                          label: dev.name || '',
                          value: dev.id || ''
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"]))]);
}